import _ from 'lodash';
import { lsErrorService, lsScheduleEventHelpers } from 'ls-vue-common';
import { ScheduleEventServiceItemIconStatusConstants } from './LsScheduleEventServiceItemConstants';
import { LONG_GRASS_TYPE } from '@/constants';
import { internationalizationMixin } from '@/mixins';

const translate = (key, params) => {
  const i18n = new internationalizationMixin();
  return i18n.$options.methods.t(key, params);
};

const getLongGrassQuote = ({ long_grass_quote, long_grass_quote_service }) => {
  if (!long_grass_quote && !long_grass_quote_service) return null;

  return {
    ...(long_grass_quote_service || {}),
    ...(long_grass_quote || {}),
    type: LONG_GRASS_TYPE.LGQ,
  };
};

const getLongGrassFee = ({ longgrasses }) => {
  if (_.isEmpty(longgrasses)) return null;

  return {
    ...longgrasses[0],
    type: LONG_GRASS_TYPE.LGF,
  };
};

const getScheduleEventServiceItemDisplayValues = ({ scheduleEvent }) => {
  let scheduleEventStatus = lsScheduleEventHelpers.getScheduleEventStatus({ scheduleEvent });
  const scheduleEventType = lsScheduleEventHelpers.getScheduleEventType({ scheduleEvent });

  if (scheduleEventType === 'manualquote') {
    scheduleEventStatus = `manualquote.${scheduleEventStatus}`;
  }

  let iconAndStatus = _.cloneDeep(ScheduleEventServiceItemIconStatusConstants[scheduleEventStatus]);

  let icon = _.get(iconAndStatus, 'icon');
  let status = _.get(iconAndStatus, 'status');

  if (!icon || !status) {
    iconAndStatus = _.cloneDeep(ScheduleEventServiceItemIconStatusConstants.fallback);
    icon = _.get(iconAndStatus, 'icon');
    status = _.get(iconAndStatus, 'status');

    lsErrorService.log({
      error: {
        message: `ScheduleEvent status and icon info not present for ${scheduleEventStatus} using fallback`,
        level: 'info',
        extra: {
          scheduleEvent,
        },
      },
    });
  }

  const startDate = _.get(scheduleEvent, status.startDatePath);
  const endDate = _.get(scheduleEvent, status.endDatePath);
  let statusText = status.text;

  // if there is a valid start and end date, as well as append string,
  // add it to the status text so long as start and end are not the same day
  if (status.appendOnMultiDate && startDate && endDate && startDate !== endDate) {
    statusText += status.appendOnMultiDate;
  }

  const longGrass = scheduleEvent
    ? getLongGrassQuote(scheduleEvent) || getLongGrassFee(scheduleEvent)
    : null;

  if (longGrass && longGrass.type === LONG_GRASS_TYPE.LGQ && scheduleEvent.status === 'skipped') {
    statusText = translate('longGrass.skippedDueToLongGrass');
  }

  return {
    id: scheduleEvent ? scheduleEvent.id : 0,
    icon,
    statusText,
    startDate: !scheduleEvent ? null : startDate,
    endDate: !scheduleEvent ? null : endDate,
    longGrass,
  };
};
//eslint-disable-next-line import/prefer-default-export
export const lsScheduleEventServiceItemHelpers = { getScheduleEventServiceItemDisplayValues };
